@for (group of getGroups(); track group.label) {
<p class="section-sub-title"><mat-icon>label</mat-icon>{{ group.label }}</p>
<div class="chips-block">
  @for (e of group.items; track e.key) {
  @let daDate = getFirstDate(group.theme, e.key);
  <mat-chip class="chip-small" [class.chip-has-firstda]="daDate"
    #tt="matTooltip"
    [matTooltip]="daDate ? 'Depuis le ' + formatFirstDate(daDate) : ''"
    matTooltipPosition="above"
    (click)="daDate && tt.show()">{{ e.label }}</mat-chip>
  }
</div>
}

@if (data().input_diversificationAutre) {
<div class="observation-callout" style="margin-top: 12px;">
  <mat-icon class="quote-icon">info</mat-icon>
  {{ data().input_diversificationAutre }}
</div>
}
